import React, { useContext, useEffect } from "react";
import {
  PlanType as PlanTypeType,
  ActionType,
  SortOptions,
} from "../../@types";
import { CONSTANTS as C, useTranslate } from "../../helpers";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { AppStore, defaultState } from "../../app/store";
import {
  AnalyticsActionType,
  Ga4Event,
} from "../../app/contexts/Analytics/types";

const SortSelector: React.FunctionComponent<{
  id?: string;
  onSortChanged: (sort: string) => void;
  defaultSort: SortOptions;
}> = ({ id, onSortChanged, defaultSort }) => {
  const {
    state: {
      planType,
      searchResultsFilters = defaultState.searchResultsFilters,
    },
    dispatch,
  } = useContext(AppStore.AppContext);
  const { sortBy } = searchResultsFilters;
  const t = useTranslate();
  const sortOptions = C.sortOptionsLabelsByPlan;
  const sortLabels = C.sortOptionsLabels;
  const sortValue = sortBy || defaultSort;

  useEffect(() => {
    // Wait half a second before firing the Tealium event as the library might not be loaded yet.
    setTimeout(
      () =>
        dispatch({
          type: AnalyticsActionType.SEND_TEALIUM_EVENT,
          settings: {
            event_action: "Find Plans - Search Results - Page Refinement",
            event_label: `Results UI: Sort Plans: ${t(
              sortLabels[defaultSort]
            )} - Default`,
            other_props: { event_noninteraction: 1 },
          },
        }),
      500
    );
  }, []);

  return (
    <div id={id} className="sortSelector__container mct-hide-print">
      <Dropdown
        className="ds-u-lg-display--flex ds-u-lg-justify-content--start ds-u-lg-align-items--baseline ds-u-margin--0"
        labelClassName="ds-u-margin-top--0 ds-u-margin-right--2 ds-u-font-weight--normal"
        onChange={(e: React.SyntheticEvent<HTMLSelectElement, Event>): void => {
          dispatch({
            type: AnalyticsActionType.SEND_TEALIUM_EVENT,
            settings: {
              event_action: "Find Plans - Search Results - Page Refinement",
              event_label: `Results UI: Sort Plans: ${t(
                sortLabels[e.currentTarget.value]
              )}`,
            },
          });

          dispatch({
            type: AnalyticsActionType.SEND_GA4_EVENT,
            settings: {
              event_name: Ga4Event.LIST_SORTED,
              text: t(sortLabels[e.currentTarget.value]),
            },
          });

          dispatch({
            type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
            payload: {
              ...searchResultsFilters,
              sortBy: e.currentTarget.value,
            },
          });
          onSortChanged(e.currentTarget.value);
        }}
        name="sort-by"
        value={sortValue}
        label={t("search_results_page.sort.label")}
        id="sort-plans-select"
        data-testid="sort-plans-select"
        options={[]}
      >
        {sortOptions[planType || PlanTypeType.MAPD].map((sortOption, index) => {
          const sortOptionKey = Object.keys(sortOption)[0];
          const sortOptionLabel = Object.values(sortOption)[0] as string;

          return (
            <option value={sortOptionKey} key={index}>
              {t(sortOptionLabel)}
            </option>
          );
        })}
      </Dropdown>
    </div>
  );
};

export default SortSelector;
